/**
 * Cookie Consent Banner Translations
 * ==================================
 */

import { Translations } from '../shared/i18n';

export const cookiesTranslations: Translations = {
  en: {
    cookieBannerTitle: 'We value your privacy',
    cookieBannerText:
      'We use essential cookies to run KontoMatch. With your consent, we also use analytics cookies to understand how the product is used so we can improve it. You can change your choice anytime.',
    cookieBannerAcceptAll: 'Accept all',
    cookieBannerRejectAll: 'Reject all',
    cookieBannerEssentialOnly: 'Essential only',
    cookieBannerLearnMore: 'Privacy policy',
    footCookieSettings: 'Cookie settings',
  },
  de: {
    cookieBannerTitle: 'Wir respektieren Ihre Privatsphäre',
    cookieBannerText:
      'KontoMatch verwendet notwendige Cookies für den Betrieb der Anwendung. Mit Ihrer Einwilligung nutzen wir zusätzlich Analyse-Cookies, um das Produkt zu verbessern. Sie können Ihre Auswahl jederzeit ändern.',
    cookieBannerAcceptAll: 'Alle akzeptieren',
    cookieBannerRejectAll: 'Alle ablehnen',
    cookieBannerEssentialOnly: 'Nur notwendige',
    cookieBannerLearnMore: 'Datenschutz',
    footCookieSettings: 'Cookie-Einstellungen',
  },
  tr: {
    cookieBannerTitle: 'Gizliliğinize önem veriyoruz',
    cookieBannerText:
      'KontoMatch\'i çalıştırmak için zorunlu çerezler kullanıyoruz. Onayınızla, ürünü iyileştirmek için analitik çerezler de kullanıyoruz. Seçiminizi istediğiniz zaman değiştirebilirsiniz.',
    cookieBannerAcceptAll: 'Tümünü kabul et',
    cookieBannerRejectAll: 'Tümünü reddet',
    cookieBannerEssentialOnly: 'Sadece gerekli',
    cookieBannerLearnMore: 'Gizlilik Politikası',
    footCookieSettings: 'Çerez Ayarları',
  },
};
